//This is a legacy API so we're gonna cram it all in one file since these requests are all gonna be refactored anyway
export default function LegacyCompareRFIApi($log, $http, $q) {
  'ngInject';

  return {
    getQuestionnaire: function (categoryId, orgId, questionnaireId) {
      //Buyer and Seller - get questionnaire
      return $http.post(
        '/aptitude/shared/QuestionnnaireServiceController/getQuestionnaire',
        {
          categoryId: categoryId,
          orgId: orgId,
          questionnaireId: questionnaireId
        },
        {
          intercept: true
        }
      );
    },

    /** Buyer only requests * */
    getSellerCAComparisons: function (categoryId, sellerIds) {
      //Buyer only - get CA comparisons
      return $http.post(
        '/aptitude/buyer/BuyerCompareSellersServiceController/getCAComparisons',
        {
          categoryId: categoryId,
          sellerIds: sellerIds
        },
        {
          intercept: true
        }
      );
    },

    getSellerRFIResponses: function (categoryId, sellerIds) {
      //Buyer only - get RFI responses
      return $http.post(
        '/aptitude/buyer/BuyerCompareSellersServiceController/getRFIResponses',
        {
          categoryId: categoryId,
          sellerIds: sellerIds
        },
        {
          intercept: true
        }
      );
    }
  };
}
